import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { changeSearchType, setRecentActionData } from '../../../../actions/app';
import { runSearch, setAppleMapSearchLocation, setDetailedMapQuery, setIsMapTab } from '../../../../actions/search';

import companyConfigs from '../../../../constants/company';
import searchTypes from '../../../../constants/searchTypes';

type EntityInfoBoxCoordinatesLinkItemProps = {
    label: string;
    dataType: string;
    topicTitle: string;
};
export default function WikiBoxInfoBoxCoordinatesLinkItem({
    label,
    dataType,
    topicTitle,
}): React.ReactElement<EntityInfoBoxCoordinatesLinkItemProps> {
    const dispatch = useDispatch();
    const withAppleMapsDetailedView = companyConfigs.features.withAppleMapsDetailedView;

    const strippedLabel = useMemo(() => label.replace('[[0:', '').replace(']]', ''), [label]);

    const convertCoordinates = (value) => {
        //eslint-disable-next-line
        const buf = value.match(/([\d\.]+)/g);
        return {
            latitude: parseFloat(buf[0]) * (value.indexOf('S') === -1 ? 1 : -1),
            longitude: parseFloat(buf[1]) * (value.indexOf('W') === -1 ? 1 : -1),
        };
    };

    const onClick = useCallback(() => {
        if (withAppleMapsDetailedView) {
            dispatch(setDetailedMapQuery(topicTitle));
            dispatch(setIsMapTab(true));
            dispatch(setRecentActionData(null));
            dispatch(setAppleMapSearchLocation(convertCoordinates(strippedLabel)));
            dispatch(changeSearchType(searchTypes.map, 'WikiBoxInfoBoxCoordinatesLinkItem :46'));
            dispatch(runSearch({ query: topicTitle }));
        }
        // eslint-disable-next-line
    }, []);

    return (
        <span datatype={dataType || undefined} className="wikiBox__value-link" onClick={onClick}>
            {strippedLabel}
        </span>
    );
}
